import React from 'react';
/*import DEBUG from "config/debug.js"*/
import moment from 'moment';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import Presenter from '../../../presenter.js'
import RequestProperties from '../../request.props.js';
import FormHelper from '../../form.js';
import MessageProperties from '../../../../../config/message.js';

// TOAST
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';

// Component
import CommentRow from '../Row/CommentRow.js';

export default class ModalCommentList extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
      loadingLoadMore   : true,
      isLoading         : false,
      MagicTotalComment : 0,
      RowElement        : [],
      SelectedNote      : this.props.SelectedNote,
      raw_data          : [],
      TmpNewComment     : null,
      NextPage 					: null,
      Register: {
        Alias           : '',
        Comment         : '',
      },
		}

    this.onRead = this.onRead.bind(this)
    this.onReadSuccess = this.onReadSuccess.bind(this)
    this.onReadFailed = this.onReadFailed.bind(this)

    this.onRegister = this.onRegister.bind(this)
    this.onRegisterSuccess = this.onRegisterSuccess.bind(this)
    this.onRegisterFailed = this.onRegisterFailed.bind(this)
	}

	generateRow(row) {
		var element = row.map((val, index) => {
			return (
        <CommentRow
          key     ={val.Alias}
          RowData ={val}
        />
      )
		})
		return element;
	}

	/* ============== READ ============== */
	onRead() {
		Presenter.ReadComment( RequestProperties.ReadCommentsProps("Read", this, this.onReadSuccess, this.onReadFailed ))
	}

	onReadSuccess(params, response){
		if(params.action === "Read") {

      this.setState({
        isLoading         : false,
        loadingLoadMore   : false,
        MagicTotalComment : response.data.count,
        NextPage          : response.data.next,
        raw_data          : response.data.results,
        // RowElement        : params.self.generateRow(response.data.results),
			})
		} else {
			params.self.setState({
        loadingLoadMore : false,
        NextPage        : response.data.next,
        raw_data        : [...this.state.raw_data, ...response.data.results],
			})
		}

	}

	onReadFailed() {
	}

	/* ============== REGISTER ============== */
	onRegister() {
		if (this.isPosting){
			return;
		}

    if(!FormHelper.ValidateForm(this.state.Register, MessageProperties)){
			return;
		}

		this.isPosting = true;

		Presenter.RegisterComment(
      RequestProperties.RegisterCommentProps(this.onRegisterSuccess, this.onRegisterFailed, this))
	}

	onRegisterSuccess(params, response) {
    toast.success(MessageProperties.SUCEESS.MODEL.COMMENT.REGISTRATION)

    let tmpData = this.state.raw_data;
    tmpData.unshift(response.data)

    this.isPosting = false;

    this.setState({
      MagicTotalComment: this.state.MagicTotalComment + 1,
      raw_data: tmpData,
      Register: {Alias  : '', Comment: ''}
    })
		this.props.updateCounterComment(this.state.SelectedNote, this.state.MagicTotalComment)
  }

  onRegisterFailed() {
		toast.error("Send comment failed")
	}


	shouldComponentUpdate(nextProps, nextState) {
		if(nextProps.SelectedNote == null){
			return false;
		}

		if(nextProps.SelectedNote != null && nextProps.SelectedNote !== nextState.SelectedNote){
      nextState.SelectedNote = nextProps.SelectedNote
			this.onRead();
			return true;
		}

		if(nextProps.SelectedNote === nextState.SelectedNote ){
			return true;
		}

		return false;
	}

	// LOADMORE
	LoadMore() {
		this.setState({
			loadingLoadMore: true
		})
		Presenter.ReadComment(
			RequestProperties.ReadCommentsProps("Next", this, this.onReadSuccess, this.onReadFailed)
		)
	}

	RenderLoadMoreButton() {

		if(this.state.loadingLoadMore){
			return (
				<button className="btn btn-default">Loading . . .</button>
			)
		} else {
			if(this.state.NextPage != null) {
				return (
					<button className="btn btn-primary" onClick={()=>this.LoadMore()}>Load More</button>
				)
			}
		}
	}

	RenderRowElement() {
   	if (this.state.isLoading) {
  		return (
  			<section>
	  			<h5 className="text-load-comment">Load Comments . . .</h5>
	  			<div className="loading-comment">
		  			<div className="animated-background one"></div>
		  			<div className="animated-background two"></div>
		  			<div className="animated-background three"></div>
	  			</div>
  			</section>
  		)
  	} else {
      if( this.state.raw_data.length > 0 ) {
        return (
          <div>
            {this.generateRow(this.state.raw_data)}
            <div className="col-md-12 text-center loadmore-in-modal">
              {this.RenderLoadMoreButton()}
            </div>
          </div>
        )
      } else {
        return (
          <div className="comment-not-found">
            <span className="icon-speech"></span>
            <p className="text-response-empty">Comment Empty</p>
          </div>
        )
      }
    }
  }

	render() {
		const {isOpen, closeModalComment, SelectedNote, SelectedAsset} = this.props

    if(SelectedNote == null) {
			return(null)
		}

		return (
			<Modal isOpen={isOpen} toggle={closeModalComment} className="modal-lg modal-asset-detail">
				<ModalHeader toggle={closeModalComment}>
					<div className="row">
						<div className="col-md-12">
							<small className>note</small>&nbsp;
							<span className="break-word-all">{SelectedNote.Name}</span>
							<small>&nbsp;from Asset <strong>{SelectedAsset.Name}</strong></small>
						</div>
					</div>
					<div className="small f-16">
						<span className="pointer" title="Asset Author">
							<i className="icon-user"></i><span className="spaceL" title="Notes Author"><span>{SelectedNote.Owner.FirstName}</span>&nbsp;<span>{SelectedNote.Owner.LastName}</span></span>
						</span>
						<span className="spaceRRR"></span>
						<span className="pointer" title="Created Time">
							<i className="icon-clock"></i><span className="spaceL">{moment(SelectedNote.CreatedTime).fromNow()}</span>
						</span>
					</div>
				</ModalHeader>

				<ModalBody>
					<div className="row">
						<div className="col-md-12">
							<div className="modal-asset-desc break-word">
								{SelectedNote.Description}
							</div>
							<hr/>
							<div className="card comment-large-input-block">
								<textarea
									className="comment-input form-control"
									name="Comment"
									id="Comment"
									cols="30"
									rows="10"
									placeholder="Leave a comment"
									value = {this.state.Register.Comment}
									onChange={ (event) => this.setState({ Register: { Comment:event.target.value } }) }>
								</textarea>
								<div className="box-btn-response">
									<button type="submit" onClick={this.onRegister} className="btn btn-success btn-send-response">Send comment</button>
								</div>
							</div>
							<hr/>
							<div className="box-comment-filter">
								<h6>{this.state.MagicTotalComment}&nbsp;Comments</h6>
							</div>
							<div className="comments">
								{this.RenderRowElement()}
							</div>
						</div>
					</div>

				</ModalBody>
			</Modal>
		);
	}
}



// WEBPACK FOOTER //
// ./src/App/asset/simple_asset/helper/component/Modal/ModalCommentList.js